import { Helmet } from 'react-helmet-async';
import { useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import { useSelector } from 'react-redux';
import BulletItem from '../../components/BulletItem/BulletItem';
import BulletList from '../../components/BulletList/BulletList';
import { Heading } from '../../components/Heading';
import OnBoardingContainer from '../../components/OnBoarding/OnBoardingContainer';
import OnBoardingCta from '../../components/OnBoarding/OnBoardingCta';

import Paragraph from '../../components/Paragraph/Paragraph';
import { useMenu } from '../../hooks/useMenu';
import useStepPost from '../../hooks/useStepPost';
import { selectSettings } from '../../store/selectors/settingsSelectors';
import useGtmStepHook from '../../util/hooks/useGtmStepHook';
import { ACCOUNT_STEP_COMPLETE, ACCOUNT_STEP_VIEW } from '../../util/gtmEvents';
import { gtmStepHelper } from '../../util/helpers/gtmHelper';

const MetalStreamSummary = () => {
  const { t } = useTranslation();
  const { activeMenu, activeItem } = useMenu();
  const { onSuccess } = useStepPost({ nextPath: activeItem?.nextPath });
  const { MetalStreamRecurringInvestment, BrokerName } = useSelector(
    selectSettings,
  );

  const { gtmStepEvent } = useGtmStepHook();

  useEffect(() => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_VIEW,
      stepLabel: 'MetalStream Summary',
    });
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const handleGtmEvent = () => {
    gtmStepHelper({
      gtmStepEvent,
      eventName: ACCOUNT_STEP_COMPLETE,
      stepLabel: 'MetalStream Summary',
    });
  };

  return (
    <OnBoardingContainer
      activeMenu={activeMenu}
      activeItem={activeItem}
      previousPath={activeItem?.previousPath}
    >
      <Helmet>
        <title>
          {t('metalstream.titleTagComplete', {
            brokerName: BrokerName,
          })}
        </title>
      </Helmet>
      <Heading mb={32}>{t('metalstream.summaryTitle')}</Heading>
      <Paragraph mb={4}>{t('metalstream.summaryInfo')}</Paragraph>
      <BulletList>
        <BulletItem>
          <Paragraph>
            {t('metalstream.autoDeposits', {
              day: MetalStreamRecurringInvestment,
            })}
          </Paragraph>
        </BulletItem>
        <BulletItem>
          <Paragraph>{t('metalstream.autoTrades')}</Paragraph>
        </BulletItem>
        <BulletItem>
          <Paragraph>{t('metalstream.lowBalance')}</Paragraph>
        </BulletItem>
      </BulletList>

      <OnBoardingCta
        onClick={() => {
          onSuccess();
          handleGtmEvent();
          gtmStepHelper({
            gtmStepEvent,
            eventName: ACCOUNT_STEP_VIEW,
            stepLabel: 'MetalStream Secure',
          });
        }}
      />
    </OnBoardingContainer>
  );
};

export default MetalStreamSummary;
